export const projectTypeForms = {
  exome_fastq: {
    name: "",
    sample_kind: "paired_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "germline",
    description: null,
    project_type: "exome_fastq",
    single_gene: "probe",
  },
  exome_vcf: {
    name: "",
    sample_kind: "single_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "germline_vcf",
    description: null,
    project_type: "exome_vcf",
    single_gene: "probe",
  },
  exome_bam: {
    name: "",
    sample_kind: "single_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "",
    description: null,
    project_type: "exome_bam",
    single_gene: "probe",
  },
  trio: {
    name: "",
    sample_kind: "paired_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "trio",
    description: null,
    project_type: "trio",
  },
  acnv: {
    name: "",
    sample_kind: "single_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "acnv_model",
    description: null,
    project_type: "acnv",
  },
  acnv_bam: {
    name: "",
    sample_kind: "single_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "acnv_bam",
    description: null,
    project_type: "acnv_bam",
  },
  fusion: {
    name: "",
    sample_kind: "paired_end",
    kit: "",
    sequencer: "mgi",
    pipeline_class: "fusion",
    description: null,
    project_type: "fusion",
  },
  nanopore:
  {
    sequencer: "nanopore",
    pipeline_class: "nanopore",
    sample_kind: "single_end",
    project_type: "exome_fastq",
    description: "",
    single_gene: "probe",
  },
  duo: {
    name: "",
    description: null,
    kit: "ces",
    sequencer: "mgi",
    sample_kind: "paired_end",
    pipeline_class: "duo",
    project_type: "duo",
  },
};
